export const powerDeparmentsAccionesRoles = {
  sideNavActions: {
    powerDeparmentsPbi: [
      'Admin',
      'Chief',
      'PowerBiViewer',
      'PowerbiWsDepartments',
    ],
    intakes: [],
    tanks: [],
    hps: [],
    plastics: [],
    lids: [],
    polyurethane: [],
    injectionMolding: [],
    compression: [],
    mezclado: [],
    mangueras: [],
    cnc: [],
    pliegues: [],
    filtros: [],
    nave4: [],
  },
};
